import React, { useContext } from 'react';
import { TYPES, TYPES_TO_COLORS } from './helper';
import AppContext from './AppContext';
import { Checkbox } from './components/Checkbox';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './components/Accordion';

function PokedexFiltersTypes() {
  const {
    handleSetTypesSelected,
    typesSelected,
  } = useContext(AppContext);

  // Same trick from generations
  const firstHalfCheckboxes: JSX.Element[] = [];
  const secondHalfCheckboxes: JSX.Element[] = [];
  TYPES.forEach((type, index) => {
    const checkbox = (
      <div key={`filter-type-${type}`} className="items-top flex space-x-2 my-1">
        <Checkbox
          checked={typesSelected.includes(type)}
          name={type}
          value={type}
          onCheckedChange={() => handleSetTypesSelected(type)}
          disabled={!typesSelected.includes(type) && typesSelected.length === 2}
        />
        <label
          key={`${type}-checkbox`}
          htmlFor="type-checkbox"
          className="text-sm font-bold leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
        >
          <p style={{ color: `rgb(${TYPES_TO_COLORS[type].join(',')})` }}>{type}</p>
        </label>
      </div>
    );
    if (index < 9) firstHalfCheckboxes.push(checkbox);
    else secondHalfCheckboxes.push(checkbox);
  });

  return (
    <Accordion type="single" collapsible>
      <AccordionItem value="types-filter">
        <AccordionTrigger>Types Filter</AccordionTrigger>
        <AccordionContent>
          <div className="grid grid-cols-2">
            {firstHalfCheckboxes}
            {secondHalfCheckboxes}
          </div>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
}

export default PokedexFiltersTypes;
